import React, { useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { MapPin } from 'lucide-react';

interface DeliveryAddressProps {
  order?: { delivery_address?: string };
  handleInputChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DeliveryAddress: React.FC<DeliveryAddressProps> = ({
  order,
  handleInputChange,
}) => {
  const [address, setAddress] = useState(order?.delivery_address || '');

  const handleSelect = (value: string) => {
    setAddress(value);
    if (handleInputChange) {
      handleInputChange({
        target: {
          name: 'delivery_address',
          value: value,
        } as EventTarget & HTMLInputElement,
      } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 relative">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 flex items-center">
        <MapPin className="w-6 h-6 mr-3 text-blue-500 dark:text-blue-400" />
        Delivery Address
      </h2>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
        searchOptions={{ componentRestrictions: { country: 'fr' } }} // Optionnel : restreindre aux adresses françaises
        debounce={300} // Optionnel : délai pour les requêtes
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }: { getInputProps: any; suggestions: any; getSuggestionItemProps: any; loading: boolean }) => (
          <div className="relative">
            <input
              {...getInputProps({
                name: 'delivery_address',
                placeholder: 'Enter delivery address...',
                className:
                  'w-full px-4 py-3 rounded-lg border bg-white dark:bg-gray-700 text-gray-900 dark:text-white border-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out',
                onFocus: (e: any) => e.target.select(),
              })}
            />
            <div className="absolute top-3 right-3 text-gray-400 dark:text-gray-500">
              <MapPin className="w-5 h-5" />
            </div>
            {suggestions.length > 0 && (
              <div className="absolute z-10 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg mt-1 w-full max-h-60 overflow-auto">
                {loading && <div className="p-2">Chargement...</div>}
                {suggestions.map((suggestion: any) => {
                  const className = suggestion.active
                    ? 'bg-blue-500 text-white cursor-pointer p-2'
                    : 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white cursor-pointer p-2';
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                      })}
                      key={suggestion.placeId}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </PlacesAutocomplete>
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        Commencez à taper pour obtenir des suggestions d'adresses.
      </p>
    </div>
  );
};

export default DeliveryAddress;
